$(document).ready(function() {
 
  $('#sellWithUsForm').submit(function(e){
    console.log("success!"); 
    var nextFirst = $('#text-202018595912').val();
    var nextLast = $('#text-202018545912').val();
    var nextEmail = $('#text-202018505912').val();
    var nextPhone = $('#text-202018455912').val();
    var nextZip = $('#text-202018335912').val();
    $('#sellWithUsForm').hide();
    $('#thankyoumessage').css("display", "block");
    
    $('#anotheritem').click(function(){
      localStorage.setItem("first", nextFirst);
      localStorage.setItem("last", nextLast);
      localStorage.setItem("email", nextEmail);
      localStorage.setItem("phone", nextPhone);
      localStorage.setItem("zip", nextZip);
      
      window.location.href = "/pages/sell-with-us-form";
      // window.location.href = "/pages/sell-with-us-form?first="+nextFirst+"&last="+nextLast+"&email="+nextEmail+"&phone="+nextPhone+"&zip="+nextZip;
    });
    
  });
  
  $('.main-image-upload').on('dragover', function (e) {
    e.preventDefault();
  });
  $('.main-image-upload').on('drop', function (e) {
    e.preventDefault();
  });
  
  $('.minor-image-upload').on('dragover', function (e) {
    e.preventDefault();
  });
  $('.minor-image-upload').on('drop', function (e) {
    e.preventDefault();
  });
  
  
  var url_string = window.location.href;
  var url = new URL(url_string);
  // var firstname = url.searchParams.get("first");
  // var lastname = url.searchParams.get("last");
  // var email = url.searchParams.get("email");
  // var brand = url.searchParams.get("brand");
  // var phone = url.searchParams.get("phone");
  // var zip = url.searchParams.get("zip");
  var firstname = localStorage.getItem("first");
  var lastname = localStorage.getItem("last");
  var email = localStorage.getItem("email");
  var brand = localStorage.getItem("brand");
  var phone = localStorage.getItem("phone");
  var zip = localStorage.getItem("zip");

  $('#text-20201522623').val(brand);
  $('#text-202018595912').val(firstname);
  $('#text-202018545912').val(lastname);
  $('#text-202018505912').val(email);
  $('#text-202018455912').val(phone);
  $('#text-202018335912').val(zip);
  
  localStorage.removeItem('first');
  localStorage.removeItem('last');
  localStorage.removeItem('email');
  localStorage.removeItem('brand');
  localStorage.removeItem('phone');
  localStorage.removeItem('zip');

  $('.radio-group input:radio').addClass('input_hidden');
  $('.radio-group label').click(function() {
    $('.radio-group label').removeClass('selected');
    $(this).addClass('selected');
  });
  
  $('.final-btn').click(function(){
    var reviewImg = $('#img1').attr("src");
    var reviewData1= $('#text-1578289992790').val();
    var reviewData2= $('#text-20201522623').val();
    var reviewData3= $('#text-1578290019686').val();
    var reviewData4= $('input[name="radio-group-1578290092677"]:checked').val();
    $('.review-img').attr('src', reviewImg);
    $('.review-data-1').html(reviewData1);
    $('.review-data-2').html(reviewData2);
    $('.review-data-3').html(reviewData3);
    $('.review-data-4').html(reviewData4);
  });
  
   $('.button-input').click(function(){
    window.scrollTo(0, 0);
  });
  
  $('#sellWithUsForm').bind('ajax:complete', function() {
	$('#sellWithUsForm').css("display", "none");
  });

  function readURL(input, id) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        $('#'+id).attr('src', e.target.result);
        $('.img-upload-center').css("display","none");
        $('#'+id).css("display","block");
      }
      reader.readAsDataURL(input.files[0]);
    }
  }
    
  $("#file-1578281782529").change(function(){
    readURL(this, "img1");
  });
  $("#file-1578289584806").change(function(){
    readURL(this, "img2");
  });
  $("#file-1578289588605").change(function(){
    readURL(this, "img3");
  });
  $("#file-1578289594437").change(function(){
    readURL(this, "img4");
  });
  $("#file-1578289597287").change(function(){
    readURL(this, "img5");
  });
});  

var designers = [
  "A Jaffe", 
  "Alexis Bittar", 
  "Alfred Dunhill", 
  "Artcarved", 
  "Balenciaga", 
  "Ball", 
  "Baraka", 
  "Barbara Bixby", 
  "Barry Brinker", 
  "Baume & Mercier", 
  "Bedat", 
  "Bell & Ross", 
  "Bernard Grosz", 
  "Bottega Veneta", 
  "Breitling", 
  "Burberry", 
  "Bvlgari", 
  "Cartier", 
  "Celine", 
  "Cento", 
  "Chanel", 
  "Charles Krypell", 
  "Charriol", 
  "Chloe", 
  "Chopard", 
  "Christian Bauer", 
  "Christopher Designs", 
  "Crivelli", 
  "David Yurman", 
  "Denise Roberge", 
  "Di Modolo", 
  "Diana", 
  "Dior", 
  "Dolce & Gabbana", 
  "Ebel", 
  "Effy", 
  "Elizabeth Rand", 
  "Faberge", 
  "Fendi", 
  "Ferragamo", 
  "Forevermark", 
  "Franck Muller", 
  "Frederick Goldman", 
  "Frey Wille", 
  "Gabriel & Co", 
  "Girard Perregaux", 
  "Givenchy", 
  "Gottlieb & Sons", 
  "Gucci", 
  "Gurhan", 
  "Henry Dunay", 
  "Hermes", 
  "Hidalgo", 
  "Honora", 
  "Ippolita", 
  "Issey Miyake", 
  "Jaeger Lecoultre", 
  "John Hardy", 
  "Jose Hess", 
  "Judith Leiber", 
  "Judith Ripka", 
  "Kieselstein", 
  "Kieselstein Cord", 
  "Konstantino", 
  "Lagos", 
  "Lauren K", 
  "Le Vian", 
  "Levian", 
  "Louis Vuitton", 
  "Luminox", 
  "M2Malletier", 
  "Marco Bicego", 
  "Mattioli", 
  "Maurice Lacroix", 
  "MCM", 
  "Michael Beaudry", 
  "Michael Bondanza", 
  "Michael Kors", 
  "Michael Werdiger", 
  "Michele", 
  "Mikimoto", 
  "Movado", 
  "Nomos",
  "Not sure",
  "Omega", 
  "Oris", 
  "Panerai", 
  "Patek Philippe", 
  "Penny Preville", 
  "Pesavento", 
  "Phillips House", 
  "Pianegonda", 
  "Pomellato Nudo", 
  "Prada", 
  "Precision Set", 
  "Ray Ban", 
  "Raymond Weil", 
  "Rego", 
  "Rhonda Faber", 
  "Ritani", 
  "Robert Lee Morris", 
  "Roberto Coin", 
  "Rolex", 
  "Scott Kay", 
  "Simon G", 
  "Staurino Fratelli", 
  "Stella Mccartney", 
  "Stephen Dweck", 
  "Stephen Webster", 
  "Steven Kretchmer", 
  "Store 5a", 
  "Swank", 
  "Swiss Army", 
  "Tacori", 
  "Tag Heuer", 
  "Tiffany & Co", 
  "Todd Reed", 
  "Tom Ford", 
  "Tourneau", 
  "Tudor", 
  "Ulysse Nardin",
  "Unknown",
  "Valentino", 
  "Van Cleef & Arpels", 
  "Vera Wang", 
  "Victorinox", 
  "Vitorinox", 
  "Wenger Sak", 
  "Wright & Lato", 
  "Yves Saint Laurent", 
  "Zagliani", 
  "Zenith"
];